const ErrorActions = {
  ADD_ERROR: 'addError',
  REMOVE_ERROR: 'removeError',
  CLEAR_ERRORS: 'clearErrors',
};

export default ErrorActions;
